/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APINamedEntity } from './APINamedEntity';
import {
    APINamedEntityFromJSON,
    APINamedEntityFromJSONTyped,
    APINamedEntityToJSON,
} from './APINamedEntity';

/**
 * 
 * @export
 * @interface APIBomTreeArticle
 */
export interface APIBomTreeArticle {
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeArticle
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeArticle
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeArticle
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeArticle
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIBomTreeArticle
     */
    isBomBase: boolean;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIBomTreeArticle
     */
    brand?: APINamedEntity;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIBomTreeArticle
     */
    articleType?: APINamedEntity;
}

/**
 * Check if a given object implements the APIBomTreeArticle interface.
 */
export function instanceOfAPIBomTreeArticle(value: object): value is APIBomTreeArticle {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('isBomBase' in value) || value['isBomBase'] === undefined) return false;
    return true;
}

export function APIBomTreeArticleFromJSON(json: any): APIBomTreeArticle {
    return APIBomTreeArticleFromJSONTyped(json, false);
}

export function APIBomTreeArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBomTreeArticle {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'number': json['number'],
        'description': json['description'] == null ? undefined : json['description'],
        'isBomBase': json['is_bom_base'],
        'brand': json['brand'] == null ? undefined : APINamedEntityFromJSON(json['brand']),
        'articleType': json['article_type'] == null ? undefined : APINamedEntityFromJSON(json['article_type']),
    };
}

export function APIBomTreeArticleToJSON(value?: APIBomTreeArticle | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'number': value['number'],
        'description': value['description'],
        'is_bom_base': value['isBomBase'],
        'brand': APINamedEntityToJSON(value['brand']),
        'article_type': APINamedEntityToJSON(value['articleType']),
    };
}

